var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradlySidebarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 620,
    viewBox: "0 0 620 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 310,
    r: 220,
    stroke: "currentColor",
    strokeOpacity: 0.3,
    strokeWidth: 28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 310,
    r: 170,
    stroke: "currentColor",
    strokeOpacity: 0.55,
    strokeWidth: 28
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 310,
    r: 120,
    stroke: "currentColor",
    strokeOpacity: 0.9,
    strokeWidth: 28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradlySidebarLogo);
export default __webpack_public_path__ + "static/media/tradlySidebarLogo.c2c54747.svg";
export { ForwardRef as ReactComponent };